import { apiClient } from './apiClient';
import type { ProductCategory, CreateProductCategoryRequest, UpdateProductCategoryRequest } from '../types/product';

// SW-94: business-defined shop categories
export const productCategoryService = {
  async getCategories(businessProfileId: string, token: string): Promise<ProductCategory[]> {
    return apiClient.get<ProductCategory[]>(`/business-profile/${businessProfileId}/product-categories`, token);
  },

  async createCategory(
    businessProfileId: string,
    data: CreateProductCategoryRequest,
    token: string
  ): Promise<ProductCategory> {
    return apiClient.post<ProductCategory>(`/business-profile/${businessProfileId}/product-categories`, data, token);
  },

  async updateCategory(
    businessProfileId: string,
    categoryId: string,
    data: UpdateProductCategoryRequest,
    token: string
  ): Promise<ProductCategory> {
    return apiClient.put<ProductCategory>(
      `/business-profile/${businessProfileId}/product-categories/${categoryId}`,
      data,
      token
    );
  },

  async deleteCategory(businessProfileId: string, categoryId: string, token: string): Promise<void> {
    return apiClient.delete(`/business-profile/${businessProfileId}/product-categories/${categoryId}`, token);
  },

  async reorderCategories(
    businessProfileId: string,
    orderedCategoryIds: string[],
    token: string
  ): Promise<void> {
    return apiClient.put(
      `/business-profile/${businessProfileId}/product-categories/reorder`,
      { orderedCategoryIds },
      token
    );
  },
};
